<template>
<div>
  <va-modal
    v-model="showModal"
    id="leadDetailsModal"
    ref="leadDetailsModal"
    :cancelText="$t('leads.back')"
    size="large"
    :showOkay="false"
    :hideDefaultActions="isMobile"
    @cancel="$emit('cancel')"
    :fixedLayout="true">

    <div slot="header" class="d-flex justify--space-between">
          <span :class="{'col-width': isMobile}">
            <span><b style="font-size:22px; margin-bottom: 1rem; font-weight: bold"
                     class="mr-2"> {{ $t('dashboard_new_evollu.kpis.labels.questionnaire_tests_number') }}</b></span>
          </span>

      <span class="close-modal-button" v-if="isMobile">
          <va-button icon="fa fa-times" @click.prevent="$emit('cancel')"></va-button>
        </span>
    </div>

    <div v-for="anamneseAnswer in anamneseAnswers">
      <h4> {{$t('evohealth.questionnaires.title')}}: {{anamneseAnswer.anamneseTitle}} </h4>
      <div v-if="anamneseAnswer" class="mt-4 mb-3">
        <div v-for="answer in anamneseAnswer.answers" :key="answer.id">
          <div class="d-flex q-a">
            <div class="col-12 col-md-10">
        <span class="q-a question">
          <p>{{answer.questionText}}</p>
        </span>
            </div>
            <div class="col-12 col-md-2">
        <span class="q-a answer">
          <p>{{answer.answerText}}</p>
        </span>
            </div>
          </div>
          <hr class="separator">
        </div>
      </div>
      <div v-else>
        {{$t('leads.details.no_answer')}}
      </div>
    </div>

  </va-modal>

</div>
</template>
<script>
export default {
  props: ['anamneseAnswers'],
  data() {
    return {
      showModal: false
    }
  },
  mounted() {
    this.showModal = true;
  },
  computed: {
    isMobile: function() {
      return window.matchMedia(`(max-width: 767px)`).matches || window.matchMedia(`(max-height: 400px)`).matches;
    },
  }
}
</script>

<style lang="scss" scoped>

  .q-a {
    margin: 0.2rem;
    p {
      margin-top: 0.3rem;
      margin-bottom: 0.3rem;
    }
  }

  .question {
    // width: 85%;
    width: calc(100% - 85px);
    margin-right: 0.5rem;
  }

  .answer p {
    color: $evollu-dark;
    font-weight: bold;
  }

  .separator {
    margin: 0.2rem;
  }
</style>
